import { createContext } from 'react';
export const MaterialContext = createContext({});
export const ThemeContext = createContext({});
